import { errorMessages } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Edit, SimpleForm, useNotify } from "react-admin";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import EditForm from "./EditForm";

const EditScheduleFreeSelectionSlot = () => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();

  return (
    <>
      <Edit
        title="Редакция на свободен избор разписание"
        actions={<BackButtonToolbar />}
        mutationMode="pessimistic"
        mutationOptions={{
          onError: e => {
            handleConflictError(e);
            const errorMessage = e.message || errorMessages[e.errorCode];
            notify(errorMessage, { type: "error" });
          },
        }}
      >
        <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
          <EditForm />
        </SimpleForm>
      </Edit>
      <ConflictErrorDialog />
    </>
  );
};

export default EditScheduleFreeSelectionSlot;
